module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceStep3.8d860790.jpg";